
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/annonce/recherche",
      function () {
        return require("private-next-pages/annonce/recherche.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/annonce/recherche"])
      });
    }
  